// src/pages/psytest/utils/scoring.js
import { CAREER_KEYS, TIE_BREAK_PRIORITY, FIT_LEVELS } from "../data/constants";

export function computeScores(answers, scoringMatrix) {
  const scores = CAREER_KEYS.reduce((acc, k) => (acc[k] = 0, acc), {});
  Object.entries(answers).forEach(([qid, opt]) => {
    const rule = scoringMatrix?.[qid]?.[opt];
    if (!rule) return;
    CAREER_KEYS.forEach((k) => {
      scores[k] += Number(rule[k] || 0);
    });
  });
  return scores;
}

export function pickTopCareer(scores) {
  const max = Math.max(...Object.values(scores));
  const topKeys = Object.keys(scores).filter((k) => scores[k] === max);
  if (topKeys.length === 1) return topKeys[0];

  for (const k of TIE_BREAK_PRIORITY) {
    if (topKeys.includes(k)) return k;
  }
  return topKeys[0];
}

// 依「每題選項該職涯最高分」相加，算出該職涯潛在滿分
export function computeMaxPossibleForCareer(scoringMatrix, careerKey) {
  let max = 0;

  Object.entries(scoringMatrix).forEach(([qid, optionsObj]) => {
    const optionScores = Object.values(optionsObj || {}).map((rule) => Number(rule?.[careerKey] || 0));
    const best = optionScores.length ? Math.max(...optionScores) : 0;
    max += best;
  });

  return max;
}

export function computeFit(score, maxPossible) {
  const safeMax = Math.max(1, Number(maxPossible || 0));
  const percentage = Math.max(0, Math.min(100, Math.round((score / safeMax) * 100)));

  // 文字分級：照你提供的分數門檻（22/17/11）
  const level = FIT_LEVELS.find((x) => score >= x.minScore) || FIT_LEVELS[FIT_LEVELS.length - 1];

  return {
    percentage,
    range: level.range,
    fitLabel: level.label,
  };
}
